<template>
    <ValidationProvider 
        :name="field"
        :rules="rules"
        v-slot="{ errors }"
        slim
    >
        <v-select
            v-model="selected"
            :items="items" 
            :label="label"  
            :error-messages="errors"       
            :clearable="clearable"
            :readonly="readonly"
            :multiple="multiple"
            menu-props="offset-y"
            :class="withMargin ? (removeRightMargin ? 'ml-4' : 'ml-4 mr-4') : ''"
            @click:clear="resetVal()"
            @change="additionalFunction(selected)"
            :item-text="itemText"
            :item-value="itemValue"  
            :disabled="disabled"
            :no-data-text="$t(noDataText)"
            :hide-details="hideDetails"
            :alvqa="alvqa"
            item-color="generalCheckbox"
            :return-object="returnObject"
            :value-comparator="valueComparator"
        >
            <template v-slot:append>
                <BaseTooltip v-if="iconTooltipText !== ''">
                    <template v-slot:content><v-icon small color="grey" :alvqa="alvqa +'-icon-info'">fa-info-circle</v-icon></template>
                    <template v-slot:text><span>{{ iconTooltipText }}</span></template>
                </BaseTooltip>
            </template>
            <template v-if="!multiple" v-slot:item="{ item }">
                <span :alvqa="item.alvqa">
                    <slot v-if="defineSlots" name="options" :item="item"></slot>
                    <div v-else>{{ $alvPlugin.isLangConst(item[itemText]) ? $t(item[itemText]) : item[itemText] }}</div>
                </span> 
            </template>
            <!-- 26.10.2020: this was below in the template but seems not needed: v-if="selection" -->
            <template 
                v-slot:selection="{ item, index }"
            >
                <span v-if="index === 0">
                    <div :alvqa="alvqa">
                        <slot v-if="defineSlots" name="selection" :item="item"></slot>
                        <div v-else>{{ $alvPlugin.isLangConst(item[itemText])? $t(item[itemText]) : item[itemText] }}</div>
                    </div>
                </span>
                <div v-if="index === 1">  (+ {{ selected.length - 1 }} {{ $t('lang_GENERIC_CAPTION_OTHERS') }})</div>
            </template>

            <!-- All select at the top -->
            <template v-if="allSelect" v-slot:prepend-item>
                <v-list-item
                    v-if="items.length !== 0"
                    ripple
                    @click="toggle"
                >
                    <v-list-item-action>
                    <v-icon color="generalCheckbox" :alvqa="alvqa + '-checkbox-all-select'">
                        {{ icon }}
                    </v-icon>
                        </v-list-item-action>
                    <v-list-item-content>
                    <v-list-item-title :alvqa="alvqa + '-checkbox-all-select-text'">
                        {{ $t('lang_GENERAL_CAPTION_SELECT_ALL') }}
                    </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </template>
        </v-select>
    </ValidationProvider>
</template>

<script>
import BaseDropdown from '../_base/BaseDropdown'
import BaseTooltip from '../_base/BaseTooltip'

export default {
    name: "BaseEditPageDropdown",
    extends: BaseDropdown,
    components: {
        BaseTooltip
    },
    props: {
        context: String,
        field: String,
        hideDetails: Boolean,
        items: {
            type: Array,
            default: []
        },
        alvqa: {
            type: String,
            default: ''
        },
        valueComparator: {
            type: Function,
            default: function(a, b) {
                // If both objects have alvId, compare them; otherwise, fallback to strict equality.
                if (a && b && a.alvId && b.alvId) {
                    return a.alvId === b.alvId;
                }
                return a === b;
            }
        },
        itemValue: {
            type: String | Function,
            default: "value"
        },
        itemText: {
            type: String | Function,
            default: "text"
        },
        selection: {
            default: false,
            type: Boolean
        },
        clearable: {
            default: true
        },
        rules: {
            type: [Object, String],
            default: ""
        },
        withMargin: {
            type: Boolean,
            default: true
        },
        removeRightMargin: {
            type: Boolean,
            default: false
        },
        inputFunction: {
            type: Function,
            default: () => {}
        },
        additionalFunction: {
            type: Function,
            default: () => {}
        },
        allSelect: {
            type: Boolean,
            default: false
        },
        returnObject: {
            type: Boolean,
            default: false
        },
        defineSlots: {
            type: Boolean,
            default: false
        },
        resetValNull: {
            type: Boolean,
            default: false
        },
        noDataText: {
            type: String,
            default: 'lang_GENERAL_CAPTION_NO_DATA_AVAILABLE'
        },
        iconTooltipText: {
            type: String,
            default: ''
        }
    },
    computed: {
        selected: {
            get() { return this.$store.getters['get'+ this.context + 'Details' + this.field] },
            set(value) { this.$store.commit('set'+ this.context + 'Details' + this.field, value) }
        },
        allSelected() {
            return this.selected.length === this.items.length
        },
        icon () {
            if (this.allSelected) return 'check_box'
            else return 'check_box_outline_blank'
        },

    },
    methods: {
        async resetVal() {
            await this.$nextTick()
            if(this.resetValNull) this.selected = null
            else this.selected = []
        },
        toggle () {
            this.$nextTick(() => {
                if(this.allSelected) {
                    this.selected = []
                } else {
                    this.selected = this.items.slice()
                }
            })
        },
    },
    
}
</script>